import Vue from 'vue'
import Vuex from 'vuex'
import service from "@/utils/request";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    systemLoading: false,
  },
  getters: {
  },
  mutations: {
    SET_LOADING:(state, action)=>{
      state.systemLoading = action
    },
  },
  actions: {
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        let params = {};
        service
            .post("/setting/getUserInfo", params)
            .then((res) => {
              if (res && res.code == "200") {
                console.log("dispatcher拿取用户信息");
                commit("SET_USER_INFO", res.data);  // 通过 commit 提交 mutation
                localStorage.setItem("mobileNumber", res.data.mobileNumber || "");
                localStorage.setItem("userId", res.data.mobileNumber || "");
                localStorage.setItem("userName", res.data.mobileNumber || "");
                localStorage.setItem("dialingCode", res.data.dialingCode || "");
                localStorage.setItem("invitationCode", res.data.inviteCode || "");
                localStorage.setItem("packageName", res.data.userPackageVO?.packageName || '');
                resolve(res.data);  // 成功时调用 resolve
              } else {
                reject("Failed to get user info");  // 失败时调用 reject
              }
            })
            .catch((err) => {
              reject(err);  // 失败时调用 reject
            });
      });
    }
  },
  modules: {
  }
})
